// extracted by mini-css-extract-plugin
export var lbContainerOuter = "C_vr";
export var lbContainerInner = "C_vs";
export var movingForwards = "C_vt";
export var movingForwardsOther = "C_vv";
export var movingBackwards = "C_vw";
export var movingBackwardsOther = "C_vx";
export var lbImage = "C_vy";
export var lbOtherImage = "C_vz";
export var prevButton = "C_vB";
export var nextButton = "C_vC";
export var closing = "C_vD";
export var appear = "C_vF";